import React from 'react';
import moment from 'moment';
import swal from 'sweetalert2';

import DateRangePickerWrapper from "../../../../../components/DatePicker/DateRangePickerWrapper";

import { fetchStatsUsersMPGTB, fetchStatsSupportersMPGTB, fetchStatsWallMPGTB } from "../../../../../actions/entities/mpgtb/users";
import connect from "react-redux/es/connect/connect";
import Chart from "chart.js";
import map from "lodash/map";

let chart;

class UsersStatsMPGTBWidget extends React.Component {
    constructor(props) {
        super(props);

        // We set the date to yesterday and we subtract 30 days
        const today = new Date();
        const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
        const start = moment(today.setDate(today.getDate() - 30 )).format('YYYY-MM-DD');

        this.state = { end, start, supporters: null, wall: null, users: null, isLoading: false }
    }

    fetchStats() {
        const { end, start, isLoading } = this.state;
        const onSuccess = (response, type) => {
            this.setState({ [type]: response });
        };
        this.setState({ isLoading: true });
        if (!isLoading) {
            this.props.dispatch(fetchStatsUsersMPGTB({
                endDate: moment(end).format('YYYY-MM-DD'),
                startDate: moment(start).format('YYYY-MM-DD'),
            }, onSuccess, (type, error) => {
                this.setState({ isLoading: false });
                swal({
                    title: `Oops...`,
                    type: 'error',
                    html: `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
                })
            }));
            this.props.dispatch(fetchStatsSupportersMPGTB({
                endDate: moment(end).format('YYYY-MM-DD'),
                startDate: moment(start).format('YYYY-MM-DD'),
            }, onSuccess, (type, error) => {
                this.setState({ isLoading: false });
                swal({
                    title: `Oops...`,
                    type: 'error',
                    html: `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
                })
            }));
            this.props.dispatch(fetchStatsWallMPGTB({
                endDate: moment(end).format('YYYY-MM-DD'),
                startDate: moment(start).format('YYYY-MM-DD'),
            }, onSuccess, (type, error) => {
                this.setState({ isLoading: false });
                swal({
                    title: `Oops...`,
                    type: 'error',
                    html: `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
                })
            }));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { isLoading, users, supporters, wall } = this.state;
        if (prevState.isLoading && users && supporters && wall) {
            this.setState({ isLoading: false });
        }
        if (prevState.isLoading && !isLoading) {
            const datasets = [{
                label: 'Users',
                backgroundColor: '#ed9728',
                xAxisID: 'date',
                yAxisID: 'members',
                data: []
            },{
                label: 'Wall',
                backgroundColor: '#9fc99e',
                xAxisID: 'date',
                yAxisID: 'members',
                data: []
            }, {
                label: 'Supporters',
                backgroundColor: '#819bb7',
                xAxisID: 'date',
                yAxisID: 'members',
                data: []
            }];

            map(users.nbOfUsers, (value, index) => {
                datasets[0].data.push({ x: moment(index).format('LL'), y: parseInt(value, 10) });
                datasets[1].data.push({ x: moment(index).format('LL'), y: parseInt(wall.nbOfUsers[index], 10) });
                datasets[2].data.push({ x: moment(index).format('LL'), y: parseInt(supporters.supporters[index], 10) });
            });

            chart.data.datasets = datasets;
            chart.update();
        }
    }

    componentDidMount() {
        // this.fetchStats();
        const ctx = document.getElementById('mpgtbStatsChart');
        if (ctx){
            chart = new Chart(ctx, {
                type: 'bar',
                data: { datasets: [] },
                options: {
                    scales: {
                        xAxes: [{
                            id: 'date',
                            type: 'time',
                            stacked: true
                        }],
                        yAxes: [{
                            id: 'members',
                            type: 'linear',
                            stacked: true
                        }]
                    }
                }
            });
        }
    }

    renderChart() {
        return (
            <div className="chart">
                <canvas id="mpgtbStatsChart"/>
            </div>
        );
    }

    render() {
        const { end, start, supporters, wall, users, isLoading } = this.state;

        return (
            <div>
                <div className="box">
                    <div className="box-header with-border">
                        <h3 className="box-title pull-left">
                            <i className="fa fa-user-circle-o"/> Stats users, wall, supporters (entre le {this.state.start} et le {this.state.end})
                        </h3><br />
                    </div>
                    <div className="box-body">
                        <div className="margin-bottom text-center">
                            <div className="inline data-range-picker">
                                <DateRangePickerWrapper
                                    initialStartDate={moment(start)}
                                    initialEndDate={moment(end)}
                                    minimumNights={0}
                                    onDatesChange={({ startDate, endDate }) => {
                                        this.setState({
                                            start: moment(startDate).format('YYYY-MM-DD'),
                                            end: moment(endDate).format('YYYY-MM-DD')
                                        });
                                    }}
                                />
                                <button
                                    className="btn btn-default"
                                    onClick={() => this.fetchStats()}
                                >
                                    <i className="fa fa-refresh"/>
                                </button>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                            <div style={{ flex: '1' }}>
                                {this.renderChart()}
                            </div>
                            <div style={{ flex: '1' }}>
                                <div className="table-responsive table-fixed-height">
                                    <table className="table table-bordered no-margin">
                                        <thead>
                                        <tr>
                                            <th className="text-center">Day</th>
                                            <th className="text-center">Users</th>
                                            <th className="text-center">Wall</th>
                                            <th className="text-center">Supporters</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            !isLoading && users && wall && supporters &&
                                            map(users.nbOfUsers, (value, index) => {
                                                return (
                                                    <tr>
                                                        <th className="text-center">{moment(index).format('LL')}</th>
                                                        <th className="text-center">{value}</th>
                                                        <th className="text-center">{wall.nbOfUsers[index]}</th>
                                                        <th className="text-center">{supporters.supporters[index]}</th>
                                                    </tr>
                                                );
                                            })
                                        }
                                        <tr>
                                            <th className="text-center">Total</th>
                                            <th className="text-center">{users ? users.total : '-'}</th>
                                            <th className="text-center">{wall ? wall.total : '-'}</th>
                                            <th className="text-center">{supporters ? supporters.total : '-'}</th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    dispatch => ({ dispatch })
)(UsersStatsMPGTBWidget);



// WEBPACK FOOTER //
// ./src/pages/Other/MPGTB/Widgets/UsersStats/index.js